import React, { useState } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ViewSoModal from "../../../components/Modal/ViewSoModal";
import PrintInvoiceModal from "../../../components/Modal/PrintInvoiceModal";

import { formatDate, formatThaiDateUi } from "../../../../utils/DateUtils";
import {
  getData,
  formatCurrency,
  parseCurrency,
} from "../../../../utils/SamuiUtils";
import { getReport } from "../../../../utils/ReportUtils";

const Main = ({ name, dataMasterList, onPageInsert, onPageUpdate }) => {
  const [filteredDetailList, setFilteredDetailList] = useState([]);
  const [docNo, setDocNo] = useState("");
  const [arName, setArName] = useState("");
  const [soTotal, setSoTotal] = useState(0);
  const [soTotalVat, setSoTotalVat] = useState(0);
  const [soNetTotal, setSoNetTotal] = useState(0);

  const onRowSelected = async (fromData) => {
    const dataDetailList = await getData(
      "API_1302_BL_D",
      `Doc_Id = ${parseCurrency(fromData.Doc_Id)} ORDER BY SO_Date, SO_No ASC`
    );

    let total = 0;
    let totalVat = 0;

    if (dataDetailList && dataDetailList.length > 0) {
      setFilteredDetailList(dataDetailList);

      for (const fromDetail of dataDetailList) {
        total += fromDetail.Item_Total;
        totalVat += fromDetail.Total_Vat;
      }
    } else {
      setFilteredDetailList([]);
    }

    setDocNo(fromData.Doc_No);
    setArName(fromData.AR_Name);
    setSoTotal(total);
    setSoTotalVat(totalVat);
    setSoNetTotal(total + totalVat);
  };

  // ทดสอบการทำค้นหาโดย SpriteZadis (ยังไม่สมบูรณ์ เดี๋ยวมาทำต่อ)
  const [searchItemTerm, setSearchItemTerm] = useState("");
  const filteredItemData = dataMasterList.filter((data) => {
    // ตรวจสอบการค้นหาตามหมายเลขและชื่อประเภทเอกสาร
    const matchesItemSearchTerm =
      data.Doc_No.toLowerCase().includes(searchItemTerm.toLowerCase()) ||
      data.AR_Name.toLowerCase().includes(searchItemTerm.toLowerCase());

    return matchesItemSearchTerm;
  });

  // เปิด Modal สำหรับดูรายละเอียดใบขาย
  const [showViewSoModal, setShowViewSoModal] = useState(false);
  const [selectedSoData, setSelectedSoData] = useState(null);
  const handleViewSoClose = () => {
    setShowViewSoModal(false);
    setSelectedSoData(null);

    // ลบ class 'modal-open' จาก body
    document.body.classList.remove("modal-open");

    // ลบ element ที่อาจถูกซ้อน เช่น backdrop ของ Modal
    const backdrops = document.getElementsByClassName("modal-backdrop");
    while (backdrops.length > 0) {
      backdrops[0].parentNode.removeChild(backdrops[0]);
    }
  };
  const handleViewSo = (soData) => {
    setSelectedSoData(soData);
    setShowViewSoModal(true);
  };

  const [showOptionInvModal, setShowOptionInvModal] = useState(false);
  const [selectBiNo, setSelectBiNo] = useState(null);
  const [selectInvNo, setSelectInvNo] = useState(null);

  return (
    <>
      <Breadcrumbs
        page={name}
        items={[
          { name: "งานบัญชี", url: "/account" },
          { name: name, url: "/invoice" },
        ]}
      />
      <div
        className="container-fluid card py-3 hidden-scrollbar"
        style={{ maxHeight: "auto", overflowY: "auto" }}
      >
        <div className="row mb-2 align-items-center">
          <div className="col-1">
            <button
              className="btn text-white mx-3"
              onClick={() => onPageInsert()}
              style={{
                backgroundColor: "rgb(239, 108, 0)",
                whiteSpace: "nowrap",
                padding: "10px",
                fontSize: "15px",
              }}
            >
              <i className="fa fa-plus" aria-hidden="true"></i> {name}
            </button>
          </div>
          <div className="col-4">
            <div className="input-group">
              <span className="input-group-text">Search</span>
              <input
                type="text"
                className="form-control"
                value={searchItemTerm}
                onChange={(e) => setSearchItemTerm(e.target.value)}
              />
            </div>
          </div>
          <div className="col-7"></div>
        </div>
        <hr />
        <div className="row">
          <div
            className="col-7 mb-1"
            style={{ borderRight: "2px solid #c7c8c9" }}
          >
            <div
              className="table-responsive"
              style={{ maxHeight: "650px", overflowY: "auto" }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "12%" }}>
                      วันที่
                    </th>
                    <th className="text-center" style={{ width: "12%" }}>
                      สถานะ
                    </th>
                    <th className="text-center" style={{ width: "16%" }}>
                      ประเภทการจ่าย
                    </th>
                    <th className="text-center" style={{ width: "12%" }}>
                      เลขใบวางบิล
                    </th>
                    <th className="text-center" style={{ width: "17%" }}>
                      เลขใบเสร็จรับเงิน
                    </th>
                    <th className="text-center" style={{ width: "22%" }}>
                      ชื่อลูกค้า
                    </th>
                    <th className="text-center" style={{ width: "8%" }}>
                      รวมราคา
                    </th>
                    <th className="text-center" style={{ width: "1%" }}>
                      <i className="fa fa-edit" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredItemData.length > 0 ? (
                    filteredItemData.map((data, index) => (
                      <tr
                        key={data.Doc_Id || index + 1}
                        onClick={() => onRowSelected(data)}
                        style={{
                          cursor: "pointer",
                          backgroundColor:
                            data.Doc_No === docNo
                              ? "rgb(105, 188, 216)"
                              : "transparent",
                          transition: "background-color 0.3s ease",
                        }}
                      >
                        <td className="text-center">
                          {formatThaiDateUi(data.Doc_Date)}
                        </td>

                        <td className="text-center">
                          {data.Doc_Status !== 13 ? (
                            <button
                              className="btn"
                              style={{
                                backgroundColor: data.DocBLStatusPaid_Colour,
                                color: "white",
                                width: "100%",
                              }}
                            >
                              {data.DocBLStatusPaid_Name}
                            </button>
                          ) : (
                            <button
                              className="btn"
                              style={{
                                backgroundColor: "black",
                                color: "white",
                                width: "100%",
                              }}
                            >
                              ยกเลิก
                            </button>
                          )}
                        </td>
                        <td className="text-center">
                          {data.DocBLStatusPaid_Name !== "จ่ายครบ" ? (
                            <p
                            // className="btn"
                            // style={{
                            //   backgroundColor: data.DocBLStatusPaid_Colour,
                            //   color: "white",
                            //   width: "100%",
                            // }}
                            >
                              -
                            </p>
                          ) : (
                            <button
                            className="btn"
                            style={{
                              backgroundColor: data.DocStatusPaid_Type_Colour,
                              color: "white",
                              width: "100%",
                            }}
                            >
                              {data.DocStatusPaid_Type_Name}
                            </button>
                          )}
                        </td>
                        <td className="text-center">{data.Doc_No}</td>
                        <td className="text-left">
                          {data.Doc_INV_No || "-"}
                          {data.Doc_INV_No && (
                            <>
                              <button
                                className="btn btn-link btn-sm px-3"
                                onClick={() => {
                                  setSelectBiNo(data.Doc_No);
                                  setSelectInvNo(data.Doc_INV_No);
                                  setShowOptionInvModal(true);
                                }}
                              >
                                <i
                                  className="fa fa-print"
                                  style={{ fontSize: "16px" }}
                                ></i>
                              </button>
                              {showOptionInvModal && (
                                <PrintInvoiceModal
                                  showOptionInvModal={showOptionInvModal}
                                  setShowOptionInvModal={setShowOptionInvModal}
                                  onHandleInvoice1={() =>
                                    getReport("inv1", selectInvNo)
                                  }
                                  onHandleInvoice2={() =>
                                    getReport("inv2", selectInvNo)
                                  }
                                  onHandleInvoice3={() =>
                                    getReport("INV_RECEIPT", selectBiNo)
                                  }
                                  invNo={selectInvNo}
                                />
                              )}
                            </>
                          )}
                        </td>
                        <td className="text-left">{data.AR_Name}</td>
                        <td className="text-end">
                          {formatCurrency(data.BL_Net_Total)}
                        </td>
                        <td className="text-center">
                          <button
                            className="btn btn-sm"
                            onClick={() => onPageUpdate(data.Doc_No)}
                          >
                            <i className="fa fa-edit" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="7">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
                {filteredItemData.length > 0 && (
                  <tfoot>
                    <tr>
                      <td
                        colSpan="8"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        <div className="row">
                          {/* รวม */}
                          <div className="col-12">
                            <span>รวมยอด วางบิล</span>
                            <span
                              style={{ paddingLeft: "10px", color: "#EF6C00" }}
                            >
                              {formatCurrency(
                                filteredItemData.reduce(
                                  (total, item) => total + item.BL_Total,
                                  0
                                )
                              )}
                            </span>
                            <span style={{ paddingLeft: "10px" }}>บาท</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
          <div className="col-5 mb-3">
            {filteredDetailList.length !== 0 && (
              <div className="justify-content-between align-items-center mb-3">
                <div className="row">
                  <div className="col-12">
                    <p className="card-title mb-0">
                      เอกสารเลขที่: {docNo} {arName}
                    </p>
                  </div>
                  <div className="col-12 d-flex justify-content-end">
                    {localStorage.getItem("company") === "1" ? (
                      <>
                        <button
                          className="btn d-flex align-items-center text-white me-2"
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                          onClick={() => getReport("bi1", docNo)}
                        >
                          <i
                            className="fa fa-print me-2"
                            aria-hidden="true"
                          ></i>
                          ใบวางบิล
                        </button>
                        {/* <button
                        className="btn d-flex align-items-center text-white"
                        style={{
                          backgroundColor: 'rgb(239, 108, 0)',
                          fontSize: '16px',
                        }}
                        onClick={() => getReport('bi2', docNo)}
                      >
                        <i className="fa fa-print me-2" aria-hidden="true"></i>
                        พิมพ์ใบวางบิล (สำเนา)
                      </button> */}
                      </>
                    ) : (
                      <>
                        <button
                          className="btn d-flex align-items-center text-white me-2"
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                          onClick={() => getReport("bi1", docNo)}
                        >
                          <i
                            className="fa fa-print me-2"
                            aria-hidden="true"
                          ></i>
                          พิมพ์ใบวางบิล 
                        </button>
                        {/* <button
                          className="btn d-flex align-items-center text-white"
                          style={{
                            backgroundColor: "rgb(239, 108, 0)",
                            fontSize: "16px",
                          }}
                          onClick={() => getReport("bl_repeat", docNo)}
                        >
                          <i
                            className="fa fa-print me-2"
                            aria-hidden="true"
                          ></i>
                          พิมพ์ใบวางบิล (ฟอร์มกระดาษต่อเนื่อง)
                        </button> */}
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}
            <div
              className="table-responsive"
              style={{
                maxHeight: "600px",
                overflowY: "auto",
              }}
            >
              <table
                id="basic-datatables"
                className="table table-striped table-hover"
                style={{ minWidth: "100%" }}
              >
                <thead className="thead-dark">
                  <tr>
                    <th className="text-center" style={{ width: "2%" }}>
                      ลำดับ
                    </th>
                    <th className="text-center" style={{ width: "9%" }}>
                      ประเภท
                    </th>
                    <th className="text-center" style={{ width: "18%" }}>
                      วันที่เอกสาร
                    </th>
                    <th className="text-center" style={{ width: "18%" }}>
                      เลขที่ใบขาย
                    </th>
                    <th className="text-center" style={{ width: "18%" }}>
                      รวมราคา
                    </th>
                    <th className="text-center" style={{ width: "14%" }}>
                      ราคา VAT
                    </th>
                    <th className="text-center" style={{ width: "30%" }}>
                      รวมสุทธิ
                    </th>
                    <th className="text-center" style={{ width: "2%" }}>
                      View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredDetailList.length > 0 ? (
                    filteredDetailList.map((item, index) => (
                      <tr key={item.DT_Id || index + 1}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">
                          <button
                            className="btn"
                            style={{
                              backgroundColor:
                                item.Doc_Is_PickingList === 0 ||
                                  item.Doc_Is_PickingList === null
                                  ? "#EAA300"
                                  : "#13A10E",
                              color: "white",
                              width: "100%",
                            }}
                          >
                            {item.Doc_Is_PickingList === 0 ||
                              item.Doc_Is_PickingList === null
                              ? "S"
                              : "V"}
                          </button>
                        </td>
                        <td className="text-center">
                          {formatDate(item.SO_Date)}
                        </td>
                        <td className="text-center">{item.SO_No}</td>
                        <td className="text-end">
                          {formatCurrency(item.Item_Total)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item.Total_Vat)}
                        </td>
                        <td className="text-end">
                          {formatCurrency(item.Item_Total + item.Total_Vat)}
                        </td>
                        <td className="text-center">
                          <i
                            className="fa fa-eye"
                            style={{ color: "#EF6C00", cursor: "pointer" }}
                            onClick={() => handleViewSo(item)}
                          ></i>
                        </td>

                        {showViewSoModal && selectedSoData && (
                          <ViewSoModal
                            showViewSoModal={showViewSoModal}
                            handleViewSoClose={handleViewSoClose} // ใช้ฟังก์ชันปิด Modal
                            mode={"U"}
                            name={`ใบขายสินค้าเลขที่ ${selectedSoData.SO_No}`}
                            maxDocNo={selectedSoData.SO_No} // ส่งหมายเลขใบขาย
                          />
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="8">
                        <center>
                          <h5>ไม่พบข้อมูล</h5>
                        </center>
                      </td>
                    </tr>
                  )}
                </tbody>
                {filteredDetailList.length > 0 && (
                  <tfoot>
                    <tr>
                      <td
                        colSpan="4"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        <div className="text-end">
                          <span>รวมราคา</span>
                        </div>
                      </td>
                      <td
                        colSpan="1"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {/* รวมราคา */}
                        <span className="text-end" style={{ color: "#EF6C00" }}>
                          {formatCurrency(soTotal)}
                        </span>
                      </td>
                      <td
                        colSpan="1"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {/* VAT */}
                        <span style={{ color: "#EF6C00" }}>
                          {formatCurrency(soTotalVat)}
                        </span>
                      </td>
                      <td
                        colSpan="1"
                        className="text-end"
                        style={{
                          fontSize: "16px",
                          fontWeight: "bold",
                          color: "#333",
                        }}
                      >
                        {/* รวมราคาสุทธิ */}
                        <span style={{ color: "#EF6C00" }}>
                          {formatCurrency(soNetTotal)}
                        </span>
                      </td>
                      <td colSpan="1"></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Main;
